import InfoIcon from '@mui/icons-material/Info';
import { Box, InputAdornment, TooltipProps as MuiTooltipProps, IconButton } from '@mui/material';
import { FC, ReactNode } from 'react';

import { WithTooltip } from './WithTooltip';

type Props = Omit<MuiTooltipProps, 'children'> & {
  ariaLabel: string;
  children?: ReactNode;
};

const TooltipAdornment: FC<Props> = ({ ariaLabel, ...props }) => {
  return (
    <InputAdornment position="end">
      <WithTooltip placement="top-end" {...props}>
        <Box display="flex">
          {props.children ?? (
            <IconButton aria-label={ariaLabel}>
              <InfoIcon />
            </IconButton>
          )}
        </Box>
      </WithTooltip>
    </InputAdornment>
  );
};

export { TooltipAdornment };
